import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/UserPayment`;

const ApiUserPayment = {
  getActivePortalList: (params) => {
    
    const url = `${baseServiceUrl}/getActivePortalList`;
    
    return ServiceApi.get(url, params);
  },
  // زمانی که مستقیم میخواد افزایش موجودی بده
  insertPayment: (params) => {
    
    const url = `${baseServiceUrl}/insertPayment`;
    
    return ServiceApi.put(url, params);
  },
  // زمانی که سبد خرید موجود است
  payment: (params) => {
    
    const url = `${baseServiceUrl}/payment`;
    
    return ServiceApi.put(url, params);
  },
  redirecttobank: (params) => {
    // 
    // const url = `${baseServiceUrl}/payment`;
    // 

    return (window.location.href = process.env.REACT_APP_API_URL + "?redirectId=" + params.link);
    //return ServiceApi.request("");
    //
  },
  getPaymentResult: (params) => {
    
    const url = `${baseServiceUrl}/getPaymentResult`;
    
    return ServiceApi.get(url, { params });
  },
};

export default ApiUserPayment;
